(()=>{
'use strict';
if(window.ffBadges)return;
const normal=s=>String(s).normalize('NFD').replace(/[\u0300-\u036f]/g,'').toLowerCase().replace(/[^a-z0-9]+/g,' ').trim();
let catalogue;
const items=()=>catalogue||(catalogue=JSON.parse(document.querySelector('[data-ff-badge-catalogue]')?.textContent||'[]'));
const cache=new Map();
const image=url=>new Promise((resolve,reject)=>{const im=new Image();im.onload=()=>resolve(im);im.onerror=()=>reject(Error('Image unavailable'));im.src=url;});
const asData=blob=>new Promise((resolve,reject)=>{const r=new FileReader();r.onload=()=>resolve(r.result);r.onerror=reject;r.readAsDataURL(blob);});
async function load(id){
  if(cache.has(id))return cache.get(id);
  const badge=items().find(b=>b.id===id);if(!badge)throw Error('Badge unavailable');
  const pending=(async()=>{
    const response=await fetch(badge.url);if(!response.ok)throw Error('Badge unavailable');
    let blob=await response.blob();if(blob.size>10*1024*1024)throw Error('Badge too large');
    if(badge.format==='svg'){
      const doc=new DOMParser().parseFromString(await blob.text(),'image/svg+xml');
      if(doc.querySelector('parsererror')||doc.documentElement.localName!=='svg')throw Error('Invalid badge');
      const svg=doc.documentElement;
      svg.querySelectorAll('script,foreignObject,iframe,object,embed').forEach(e=>e.remove());
      for(const e of [svg,...svg.querySelectorAll('*')])for(const a of [...e.attributes]){
        if(/^on/i.test(a.name)||(/href$/i.test(a.name)&&!a.value.startsWith('#')&&!/^data:image\/(png|jpeg|webp);base64,/i.test(a.value)))e.removeAttribute(a.name);
      }
      svg.querySelectorAll('style').forEach(e=>{if(/@import|url\(\s*['"]?(?!#)/i.test(e.textContent))e.remove();});
      const vb=(svg.getAttribute('viewBox')||'').trim().split(/[ ,]+/).map(Number);
      const w=vb.length===4&&vb[2]>0?vb[2]:parseFloat(svg.getAttribute('width'))||1000;
      const h=vb.length===4&&vb[3]>0?vb[3]:parseFloat(svg.getAttribute('height'))||1000;
      if(!vb.length||vb.length!==4)svg.setAttribute('viewBox',`0 0 ${w} ${h}`);
      const scale=2048/Math.max(w,h);svg.setAttribute('width',Math.max(1,Math.round(w*scale)));svg.setAttribute('height',Math.max(1,Math.round(h*scale)));
      svg.setAttribute('xmlns','http://www.w3.org/2000/svg');
      blob=new Blob([new XMLSerializer().serializeToString(svg)],{type:'image/svg+xml'});
    }
    const data=await asData(blob),im=await image(data);
    if(im.naturalWidth*im.naturalHeight>40000000)throw Error('Badge too large');
    return{badge,image:im,data};
  })();
  cache.set(id,pending);pending.catch(()=>cache.delete(id));return pending;
}
function mount(picker,onSelect){
  const $=s=>picker.querySelector(s),labels=JSON.parse($('[data-badge-labels]').textContent),search=$('[data-badge-search]'),league=$('[data-badge-league]'),results=$('[data-badge-results]'),more=$('[data-badge-more]'),err=$('[data-badge-error]');
  let limit=24,selected='',choosing=false;
  for(const option of league.options){const count=items().filter(b=>!option.value||b.league===option.value).length;option.textContent+=` (${count})`;}
  const message=t=>{err.textContent=t;err.hidden=!t;};
  function render(){
    const q=normal(search.value),found=items().filter(b=>(!league.value||b.league===league.value)&&normal([b.name,...b.aliases].join(' ')).includes(q));
    $('[data-badge-count]').textContent=found.length?labels.count.replace('[count]',found.length):labels.none;
    results.replaceChildren(...found.slice(0,limit).map(b=>{
      const button=document.createElement('button');button.type='button';button.className='ff-badge-option';button.dataset.badgeId=b.id;button.setAttribute('aria-pressed',String(selected===b.id));button.disabled=choosing;
      const img=document.createElement('img');img.src=b.url;img.loading='lazy';img.width=64;img.height=64;img.alt='';img.addEventListener('error',()=>{button.disabled=true;button.title=labels.failed;});
      const name=document.createElement('span');name.textContent=b.name;button.append(img,name);
      button.addEventListener('click',async()=>{if(choosing)return;choosing=true;message('');$('[data-badge-count]').textContent=labels.loading;results.querySelectorAll('button').forEach(e=>e.disabled=true);try{await onSelect(b);selected=b.id;$('[data-badge-selection]').textContent=b.name;picker.open=false;}catch{message(labels.failed);}finally{choosing=false;render();}});
      return button;
    }));more.hidden=found.length<=limit;
  }
  picker.addEventListener('toggle',()=>{if(picker.open)render();});
  search.addEventListener('input',()=>{league.value='';limit=24;message('');render();results.scrollTop=0;});
  search.addEventListener('keydown',e=>{if(e.key==='Enter')e.preventDefault();});
  league.addEventListener('change',()=>{search.value='';limit=24;message('');render();results.scrollTop=0;});
  more.addEventListener('click',()=>{limit+=24;render();});
  return{select(id){selected=id||'';$('[data-badge-selection]').textContent=items().find(b=>b.id===id)?.name||'';if(picker.open)render();},close(){picker.open=false;}};
}
window.ffBadges={items,load,mount};
})();
